import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { parseISO, format, isValid } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import styles from '../styles/DatePicker.module.css';

/**
 * Wrapper around react-datepicker.
 * value: ISO string "YYYY-MM-DD" (same as input[type="date"])
 * onChange: called with "YYYY-MM-DD" or "" when cleared
 */
const DatePicker = ({ value, onChange, placeholder = 'dd-MMM-yyyy', required, className, disabled = false }) => {
  const selected = value ? (() => {
    const d = parseISO(value);
    return isValid(d) ? d : null;
  })() : null;

  const handleChange = (date) => {
    if (!date) { onChange(''); return; }
    onChange(format(date, 'yyyy-MM-dd'));
  };

  return (
    <ReactDatePicker
      selected={selected}
      onChange={handleChange}
      dateFormat="dd-MMM-yyyy"
      placeholderText={placeholder}
      required={required}
      disabled={disabled}
      readOnly={disabled}
      autoComplete="off"
      className={`${styles.input} ${disabled ? styles.inputDisabled : ''} ${className || ''}`}
      calendarClassName={styles.calendar}
      showPopperArrow={false}
      popperPlacement="bottom-start"
    />
  );
};

export default DatePicker;
